import Slider from '@/modules/Slider';
import { exists } from '@/helpers/utilities';

export let sliders = {
    init() {
        /*———— -Testimonial Slider- ————*/
        let nextButton = `[data-js="testimonial-slider-controls"] [data-action="next"]`;
        let prevButton = `[data-js="testimonial-slider-controls"] [data-action="prev"]`;

        Slider.init({
            selector: '[data-js="testimonial-slider"]',
            config: {
                controls: true,
                nav: false,
                nextButton: nextButton,
                prevButton: prevButton,
                autoHeight: false,
            },
        });
    },
};
